import type {
  CardType,
  CreatureKind,
  Gender,
  TargetSpec,
  TerritoryCategory,
  UnitFilter,
} from '../types/catalog';

/** Rótulos em português para os tipos de carta (singular). */
export const CARD_TYPE_LABEL: Record<CardType, string> = {
  unit: 'Unidade',
  spell: 'Feitiço',
  trap: 'Armadilha',
};

/** Rótulos no plural, usados nos filtros. */
export const CARD_TYPE_LABEL_PLURAL: Record<CardType, string> = {
  unit: 'Unidades',
  spell: 'Feitiços',
  trap: 'Armadilhas',
};

/** Nome legível de cada tag de criatura. */
export const CREATURE_KIND_LABEL: Record<CreatureKind, string> = {
  gado: 'Gado',
  felina: 'Felina',
  autoridade: 'Autoridade',
  politico: 'Político',
  intergalactico: 'Intergaláctico',
  esquerdopata: 'Esquerdopata',
  crime: 'Crime',
  bostileiros: 'Bostileiros',
  artista: 'Artista',
};

export const GENDER_LABEL: Record<Gender, string> = {
  male: 'Masculino',
  female: 'Feminino',
  fluid: 'Fluido',
};

/** Categoria de território -> rótulo + cor de destaque. */
export const TERRITORY_CATEGORY: Record<
  TerritoryCategory,
  { label: string; color: string; help: string }
> = {
  // Cores alinhadas ao tema do app (colors.accent / colors.primary / hexLose).
  light: {
    label: 'Leve',
    color: '#3ddc84',
    help: 'Efeito sutil, que altera pouco o ritmo da partida.',
  },
  medium: {
    label: 'Médio',
    color: '#ffc21e',
    help: 'Efeito relevante, capaz de moldar as decisões do território.',
  },
  heavy: {
    label: 'Pesado',
    color: '#ff476f',
    help: 'Efeito forte, que pode virar o jogo se for bem explorado.',
  },
};

const UNIT_FILTER_LABEL: Record<UnitFilter, string> = {
  anyUnit: 'qualquer unidade',
  enemyUnit: 'uma unidade inimiga',
  allyUnit: 'uma unidade aliada',
};

/** Descreve, em português, o alvo exigido por um feitiço. */
export function describeTargetSpec(spec: TargetSpec): string {
  switch (spec.kind) {
    case 'none':
      return 'Sem alvo (efeito global)';
    case 'singleUnit':
      return `Alvo: ${UNIT_FILTER_LABEL[spec.filter]}`;
    case 'territory':
      return 'Alvo: um território';
    case 'multipleUnits':
      return `Alvo: ${spec.count} × ${UNIT_FILTER_LABEL[spec.filter]}`;
    default: {
      // Exaustividade: se um novo tipo de alvo surgir no protocolo, o TS avisa.
      const _exhaustive: never = spec;
      return _exhaustive;
    }
  }
}
